export default {
    title: 'Planète insolite',
    subTitle: 'Quelques chiffres et informations, exemples de bouleversements qui préfigurent le monde de demain.',

    figures_title_1: '87.3',
    figures_unit_1: 'Milliards de dollars',
    figures_content_1: 'Milliards de dollars, c’est le chiffre d’affaires généré en 2015 par la filière bio. L’amérique du nord et l’europe représentent respectivement 49 % et 39,7 % de la consommation mondiale de bio.',
    figures_caption_1: '(Agence Bio, 2017)',

    figures_title_2: '36',
    figures_unit_2: 'Milliards d’objets connectés d’ici à 2030',
    figures_content_2: 'L’Internet des objets (ou IoT) est un marché à fort potentiel, tiré par les applications industrielles. Le marché des entreprises devait dépasser les 964 milliards de dollars en 2017.',
    figures_caption_2: '(DigiWorld Yearbook 2017 ; étude Gartner 2017)',

    world_title: 'EN 2050,',
    world_abstract: 'plus des deux tiers de l’humanité vivra en ville. Pratiquement, 7 personnes sur 10, contre 1 sur 2 aujourd’hui, selon l’ONU.',
    world_city: 'monde',

    tokyo_title: '+ DE 16 MILLIONS DE TONNES',
    tokyo_abstract: 'de gisements de terres rares, utilisées dans les produits de haute technologie, reposeraient au fond de l’océan Pacifique, à quelque 2000 km de Tokyo. Ces gisements représenteraient des centaines d’années de consommation mondiale de minéraux précieux, tels le dysprosium et l’yttrium. (Scientific Reports, April 2018)',
    tokyo_city: 'Tokyo',
    tokyo_link: 'go.nature.com/2Kpgo9A',

    newyork_title: '20 HEURES. LE VOL LE PLUS LONG DU MONDE',
    newyork_abstract: 'Singapore Airlines propose, depuis octobre, le plus long vol commercial au monde avec son A350-900 reliant Singapour à New York. C’est Qatar Airways qui détenait jusqu’alors le record avec son vol Doha- Auckland, qui représente déjà plus de seize heures.',
    newyork_city: 'New York',

    usa_title: 'POUPÉE MODÈLE',
    usa_abstract: 'La célèbre poupée Barbie fait évoluer son image en lançant un modèle d’ingénieure en robotique, en partenariat avec une plate- forme d’initiation au codage informatique. Ceci afin de susciter des vocations chez les petites filles...',
    usa_city: 'ÉTATS-UNIS',

    china_title: 'LA CONNECTIVITÉ',
    china_abstract: 'est le nouveau moteur de l’automobile. Le marché global des véhicules connectés devrait atteindre plus de 100 milliards d’euros en 2020. Et la Chine serait un eldorado pour les constructeurs, ses conducteurs étant les plus ouverts aux services innovants. (Connected Car, Kantar TNS)',
    china_city: 'Chine',
    china_link: 'bit.ly/2Be6GkP',

    sweden_title: 'PROTÉGÉS ET STYLÉS',
    sweden_abstract: 'Deux étudiantes suédoises (société Hövding) ont inventé le casque de vélo « invisible ». Cet airbag se porte comme une écharpe autour du cou. En cas de choc, une petite bombe d’hélium gonfle automatiquement l’airbag qui enveloppe la tête. Quand sécurité rime avec élégance...',
    sweden_city: 'SUÈDE',

    germany_title: '1000 MILLIARDS',
    germany_abstract: 'd’arbres plantés sur la Terre pour lutter contre le changement climatique : tel est l’objectif de Plant-for-the-Planet. 67 000 enfants dans le monde participent à cette initiative lancée en Allemagne en 2007. Ils ont déjà planté plus de 15 milliards d’arbres dans 193 pays.',
    germany_city: 'Allemagne',
    germany_link: 'www.plant-for-the-planet.org',

};
